<script>
  import TheHeader from './components/TheHeader'
  import TheFooter from './components/TheFooter'

export default {
  components: {
    'TheHeader': TheHeader,
    'TheFooter': TheFooter,
  },
}

</script>
<template>
  <div id="app">
    <TheHeader :key="$route.fullPath"></TheHeader>

    <router-view/>

    <TheFooter></TheFooter>
  </div>
</template>

<style>
  @import "https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/css/style.css?ver=2.12";

</style>
